import { useNavigate, useParams } from "react-router-dom"
import BasePage from "../../components/layout/BasePage"
import { useQuery } from "@tanstack/react-query"
import { getProjectDetail } from "./api/apiCalls"
import BaseHeadline from "../../components/general/BaseHeadline"
import Loading from "../../components/common/Loading"
import TextSection from "./components/TextSection"
import { useEffect } from "react"
import { getHowWeOperate } from "../Homepage/api/apiCalls"
import BaseLabel from "../../components/general/BaseLabel"
import { API } from "../../api/api"
import BaseScreenImage from "../../components/general/BaseScreenImage"
import BeforeAfter from "./components/BeforeAfter"
import ProcessSection, { ProcessSectionHeadingType, ProcessSectionStepType } from "../../components/common/ProcessSection"
import ContactCTA from "../../components/common/ContactCTA"

export default function ProjectDetailPage() {
    const { id } = useParams()

    const { data, isLoading } = useQuery({
        queryKey: ["projectDetail", id],
        queryFn: () => getProjectDetail(id ?? ""),
    })

    const { data: howWeOperate, isLoading: howWeOperateLoading } = useQuery({
        queryKey: ["howWeOperate"],
        queryFn: () => getHowWeOperate(),
    })

    // check if page has a project detail section
    const navigate = useNavigate()
    useEffect(() => {
        if (data?.hasDetailPage === false) {
            navigate("/portfolio")
        }
    }, [data, navigate])

    if (isLoading || howWeOperateLoading || !data || !howWeOperate) {
        return <Loading />
    }

    const projectSteps: ProcessSectionStepType[] | undefined = data?.processStep?.map(
        (step: { number: string; headline: string; text: string }) => ({
            attributes: {
                number: step.number,
                headline: step.headline,
                description: step.text,
            },
        })
    )

    const processSteps = projectSteps?.length ? projectSteps : howWeOperate

    const stepsCount = processSteps?.length ?? 0

    const processHeading: ProcessSectionHeadingType = data?.processHeading
        ? {
            label: data.processHeading.label,
            headline: data.processHeading.headline ?? `In ${stepsCount} klaren Schritten zum Ziel`,
            text: data.processHeading.text,
        }
        : {
            label: "Unser Prozess",
            headline: `In ${stepsCount} klaren Schritten zum Ziel`,
            text: "Von der ersten Idee bis zum fertigen Produkt – wir begleiten Sie transparent und partnerschaftlich auf dem gesamten Weg.",
        }

    return (
        <BasePage>

            <section className="flex flex-col gap-2 w-full max-w-page mx-auto pt-8 px-4 md:px-8 xl:px-0 mt-40 pb-24">
                {data?.customer_logo &&
                    <div className=" mb-6 sm:hidden">
                        <img
                            src={API.img + data.customer_logo.data?.attributes?.url}
                            alt={data?.headline}
                            className="w-40 h-auto object-contain"
                        />
                        {/* <div className="w-[1px] bg-accent" /> */}
                    </div>
                }
                {data?.preview?.sublabel && <BaseLabel label={data.preview.sublabel} />}
                <div className="flex gap-8 items-center">
                    {data?.customer_logo &&
                        <div className="pr-8 border-r border-accent hidden sm:block">
                            <img
                                src={API.img + data.customer_logo.data?.attributes?.url}
                                alt={data?.headline}
                                className="w-40 h-auto object-contain"
                            />
                            {/* <div className="w-[1px] bg-accent" /> */}
                        </div>
                    }
                    <BaseHeadline headline={data?.headline} classProps="!justify-start max-w-xl" headlineClassProps="text-start !mb-0 !pb-0 !text-4xl font-medium" />

                </div>

            </section>
            <BeforeAfter Previous={data?.Previous || []} After={data?.After || []} />

            <BaseScreenImage
                url={data?.screenshot.data?.attributes?.url}
                alt={data?.headline}
            />
            <TextSection {...data} />
            <ProcessSection
                heading={processHeading}
                steps={processSteps || []} />
            <ContactCTA />
        </BasePage>
    )
}
